import { Form } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import InputNumber from "../../../../../components/Input/InputNumber.tsx"
import { type SettingsCompanyFormData } from "../SettingsCompanyForm.tsx"

export function CompanyInvoiceDefaultsFormSection() {
  const { t } = useTranslation()

  return (
    <>
      <Form.Item<SettingsCompanyFormData>
        label={t("settings.company.defaultTaxPct")}
        name="default_tax_pct"
      >
        <InputNumber
          min={0}
          max={100}
          precision={2}
          suffix="%"
          className="w-full"
          placeholder={t("settings.company.defaultTaxPctPlaceholder")}
        />
      </Form.Item>

      <Form.Item<SettingsCompanyFormData>
        label={t("settings.company.defaultRetainagePct")}
        name="default_retainage_pct"
      >
        <InputNumber
          min={0}
          max={100}
          precision={2}
          suffix="%"
          className="w-full"
          placeholder={t("settings.company.defaultRetainagePctPlaceholder")}
        />
      </Form.Item>
    </>
  )
}
